import { del, get, put } from "@beatbox/voice-core";
/**
 * Rehearsal session metadata (attempts/tags — never audio). Kept in the
 * existing `progress` store under a `rehearsal:` prefix; dedicated stores
 * (idea.md §12) require a DB version bump and are a follow-up.
 */
const PREFIX = "rehearsal:session:";
const INDEX_KEY = "rehearsal:index";
export async function saveRehearsalSession(s) {
    await put("progress", PREFIX + s.sessionId, s);
    const idx = (await get("progress", INDEX_KEY)) ?? [];
    if (!idx.includes(s.sessionId)) {
        idx.push(s.sessionId);
        await put("progress", INDEX_KEY, idx);
    }
    console.info(`[rehearsal] saved session '${s.sessionId}' attempts=${s.attempts.length}`);
}
export async function loadRehearsalSession(id) {
    return (await get("progress", PREFIX + id)) ?? null;
}
export async function listRehearsalSessionIds() {
    return (await get("progress", INDEX_KEY)) ?? [];
}
export async function deleteRehearsalSession(id) {
    await del("progress", PREFIX + id);
    const idx = (await get("progress", INDEX_KEY)) ?? [];
    await put("progress", INDEX_KEY, idx.filter((x) => x !== id));
    console.info(`[rehearsal] deleted session metadata '${id}'`);
}
